<div class="ant-select-item-option-content" data-test-id="relationship-dropdown-option">
  <span class="select-item-text-content-wrap">
    <ng-container *ngIf="!customContent">{{ label }}</ng-container>
    <ng-template *ngIf="customContent" [ngTemplateOutlet]="template"></ng-template>
  </span>
  <ng-template *ngIf="selected && icon" [ngTemplateOutlet]="icon"></ng-template>
</div>
